export default __webpack_public_path__ + "media/images/carousel/29-28c58acede05a8902420278eeb9823d5.png";